
import { getSubtasks } from '@homeservices/api-kit/search/subtasks/v3';

export default {
  namespaced: true,
  state () {
    return {
      query: '',
      selectedQuery: '',
      results: [],
      isLoading: false,
    };
  },
  getters: {
    query: ({ query }) => query,
    selectedQuery: ({ selectedQuery }) => selectedQuery,
    results: ({ results }) => results,
    isLoading: ({ isLoading }) => isLoading,
  },
  actions: {
    async searchForServices ({ commit }, { query, size = 10 }) {
      commit('setIsLoading', true);
      commit('setQuery', query);
      const { data: results } = await getSubtasks({
        query,
        size,
      });
      commit('setResults', results);
      commit('setIsLoading', false);
    },
    selectQuery ({ commit, state }) {
      const { query } = state;
      commit('setSelectedQuery', query);
    },
    reset ({ commit }) {
      return commit('resetSearch');
    },
  },
  mutations: {
    setQuery (state, data) {
      state.query = data;
    },
    setSelectedQuery (state, data) {
      state.selectedQuery = data;
    },
    setResults (state, data) {
      state.results = data.results;
    },
    resetSearch (state) {
      state.selectedQuery = '';
      state.query = '';
      state.results = [];
    },
    setIsLoading (state, value) {
      state.isLoading = value;
    },
  },
};
